import { getTraderBalance } from 'api/rest/traders/getTraderBalance';
import { getDataAtom } from 'utils/atoms/dataAtom';
import {
  getDataFetchingAtom,
  getDataRefreshingAtom,
} from 'utils/atoms/dataFetchingAtom';

import { TraderBalances } from '../models/Trader';

export const traderBalanceAtom = getDataAtom<TraderBalances>();

export const fetchTraderBalanceAtom = getDataFetchingAtom<
  TraderBalances,
  undefined
>(traderBalanceAtom, getTraderBalance);

export const refreshTraderBalanceAtom = getDataRefreshingAtom<
  TraderBalances,
  undefined
>(traderBalanceAtom, getTraderBalance);
